import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import classNames from 'classnames';

const styles = (theme) => ({
	question: {
		padding: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 4}px`,
		display: 'flex',
		alignItems: 'center'
	},
	num: {
		padding: '6px 12px',
		marginRight: theme.spacing.unit * 2,
		borderRadius: '50%',
		backgroundColor: grey[200],
		fontWeight: 600,
		display: 'flex',
		alignSelf: 'self-start'
	}
});

class Question extends Component {
	renderQuestionNum() {
		const { classes, questionNum } = this.props;

		if (questionNum) {
			return (
				<Typography
					variant="title"
					className={classNames(classes.num)}
					color="default"
				>
					{questionNum}
				</Typography>
			);
		}

		return undefined;
	}

	render() {
		const { classes, text } = this.props;

		return (
			<div className={classes.question}>
				{this.renderQuestionNum()}
				<Typography
					variant="headline"
					dangerouslySetInnerHTML={{ __html: text }}
					color="default"
				/>
			</div>
		);
	}
}

Question.propTypes = {
	classes: PropTypes.object.isRequired,
	text: PropTypes.string.isRequired,
	questionNum: PropTypes.number,
};

Question.defaultProps = {
	questionNum: undefined,
};

export default compose(
	withStyles(styles)
)(Question);
